__turbopack_context__.v({
  "achievements": "index-module-scss-module__vWoYMq__achievements",
  "contact": "index-module-scss-module__vWoYMq__contact",
  "info": "index-module-scss-module__vWoYMq__info",
  "privateUser": "index-module-scss-module__vWoYMq__privateUser",
  "privateUserWrapper": "index-module-scss-module__vWoYMq__privateUserWrapper",
  "userStats": "index-module-scss-module__vWoYMq__userStats",
  "userStatsButton": "index-module-scss-module__vWoYMq__userStatsButton",
  "userStatsCounter": "index-module-scss-module__vWoYMq__userStatsCounter",
  "userStatsLabel": "index-module-scss-module__vWoYMq__userStatsLabel",
});
